import React,{useState, useEffect} from 'react'
import HeroCard from '../../components/causeBranding/HeroCard'
import Popup from '../../components/popup/Popup';
import './MarketingBrands.css'
import PartnersLogo from '../../components/causeBranding/PartnersLogo'
import Testimony from '../../components/home/testimony/Testimony'
import HowItWorks from '../../components/causeBranding/HowItWorks'
import Accordion from '../../components/causeBranding/Accordion'
import ImpactStore from '../../components/marketingBrands/ImpactStore';
import Millennials from '../../components/causeBranding/Millennials';
import { images } from '../../assets';

function MarketingBrands() {

  const [showPopup, setShowPopup] = useState(false);

  // Function to toggle the visibility of the pop-up form
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

  // const faqs = [
  //   {
  //     question: 'What is The Impact Store?',
  //     answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
  //   },
  //   {
  //     question: 'What makes Impact one of a kind employee wellness platform?',
  //     answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
  //   },
  //   {
  //     question: 'What is the cost?',
  //     answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
  //   },
  //   {
  //     question: 'How do I get started?',
  //     answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
  //   }

  // ];

  const customClass={
    heroTextTitle:"marketingHeroTitle",
    heroTextInfo:"marketingTextInfo",
    customButton:"becomePartnerButton",
    handMobile:"marketingMobile",
    causeMobile:"marketingInHand"
};

const millennialsClass={
  boxStats:"boxStats",
  analyticsGirl:"fitnessgirl",
  firstTitle:"firstTitle"
}

  return (
    <>
      <HeroCard
      title="Advertise smarter with The Impact Store"
      description="Engage to a community of 300K+ monthly active users by offering them exciting rewards and discounts. On Impact, our users walk or jog for a cause they care, and earn Impact-coins. They use these coins to unlock exclusive deals and discounts from the country's best brands."
      statistics={[
        { label: 'Monthly Active Users', value: '300K+' },
        { label: 'Offers Redeemed', value: '5L+' },
        { label: 'Daily Store Impression', value: '100K+' }
      ]}
      buttonText="Become a Partner"
      className={customClass}
      onButtonClick={togglePopup}
      handMobileSrc={images.marketingMobile}
      // causeMobileSrc="../../../public/ImpactLeague/Leaderboard.png"
    />
      {/* <PartnersLogo className="marketingBrandsLogos" /> */}
      <Millennials
        mTitle="Millennials and GenZ worldwide are looking for"
        mTitleMessage="21st Century customer is smart"
        mSubText="So the 21st century marketers need to level up their game. The smartest way to stand out from the bombarding noise of the advertising world is to connect with people’s hearts. When you reward a user for the social impact s/he has created, it touches a chord."
        boxTitles={["TOTAL USERS COMMUNITY", "MONTHLY ACTIVE USERS", "AGE OF USER BASE", "OFFER REDEMPTIONS ", "STORE PAGE VIEWS"]}
        boxData={["4 Million+", "300K+", "18-35 yo", "5L+", "324K+"]}
        dailyActiveUsers="TIME SPENT"
        dailyActiveUsersData="10mins"
        className={millennialsClass}
        analyticsGirl= {windowWidth<=821? images.analyticGirl : images.fitnessGirl}
      />
      <HowItWorks />
      {/* <Testimony  /> */}
      {/* <Accordion faqs={faqs} Faqs="marketingFaqs" /> */}
      <ImpactStore 
      buttonText="Become a Partner"
      className={customClass}
      onButtonClick={togglePopup} />
      <Popup showPopup={showPopup} togglePopup={togglePopup} />
    </>
  )
}

export default MarketingBrands
